var _symbol, _symbol2, _symbol3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCytiva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "orbit-around",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55 16.45 17 23.9 15.05 25.85 11.05 21.85V24.1Q11.05 29.45 14.875 33.275Q18.7 37.1 24.05 37.1Q25.5 37.1 26.8 36.85Q28.1 36.6 29.25 36.1L31.4 38.25Q29.6 39.25 27.775 39.675Q25.95 40.1 24.05 40.1Q17.5 40.1 12.775 35.375Q8.05 30.65 8.05 24.1V21.85L4.05 25.85L2.1 23.9ZM38.5 31.65 31.05 24.2 33.05 22.2 37 26.15V24.1Q37 18.75 33.175 14.925Q29.35 11.1 24 11.1Q22.55 11.1 21.25 11.375Q19.95 11.65 18.8 12.05L16.65 9.9Q18.45 8.9 20.275 8.5Q22.1 8.1 24 8.1Q30.55 8.1 35.275 12.825Q40 17.55 40 24.1V26.25L44 22.25L45.95 24.2Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "pan",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.3V9.9L18.3 14.1L16.1 11.9L24 4L31.9 11.9L29.7 14.1L25.5 9.9V19.3ZM24 44 15.85 35.85 18.05 33.65 22.5 38.1V28.65H25.5V38.1L29.95 33.65L32.15 35.85ZM36.1 31.9 33.9 29.7 38.1 25.5H28.7V22.5H38.1L33.9 18.3L36.1 16.1L44 24ZM11.9 31.9 4 24 11.95 16.05 14.15 18.25 9.9 22.5H19.35V25.5H9.9L14.1 29.7Z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "zoom-in",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8 41.95 26.65 28.8Q25.15 30.1 23.15 30.825Q21.15 31.55 18.9 31.55Q13.5 31.55 9.75 27.8Q6 24.05 6 18.75Q6 13.45 9.75 9.7Q13.5 5.95 18.85 5.95Q24.15 5.95 27.875 9.7Q31.6 13.45 31.6 18.75Q31.6 20.9 30.9 22.9Q30.2 24.9 28.8 26.65L42 39.75ZM18.85 28.55Q22.9 28.55 25.75 25.675Q28.6 22.8 28.6 18.75Q28.6 14.7 25.75 11.825Q22.9 8.95 18.85 8.95Q14.75 8.95 11.875 11.825Q9 14.7 9 18.75Q9 22.8 11.875 25.675Q14.75 28.55 18.85 28.55ZM20.3 24.3H17.3V20.2H13.2V17.2H17.3V13.15H20.3V17.2H24.35V20.2H20.3Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCytiva);
export default __webpack_public_path__ + "static/media/cytiva.62ece564ca2c71d85c480379cca82508.svg";
export { ForwardRef as ReactComponent };